import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { observer } from 'mobx-react';
import { Tooltip } from '@jbrowse/plugin-wiggle';
var en = function en(n) {
  return n.toLocaleString('en-US');
};
var toP = function toP() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return +(+s).toFixed(1);
};
var pct = function pct(n, total) {
  return "".concat(toP(n / (total || 1) * 100), "%");
};
var TooltipContents = React.forwardRef(function (_ref, reactRef) {
  var feature = _ref.feature;
  var start = feature.get('start');
  var end = feature.get('end');
  var name = feature.get('refName');
  var _feature$get = feature.get('snpinfo'),
    refbase = _feature$get.refbase,
    all = _feature$get.all,
    total = _feature$get.total,
    ref = _feature$get.ref,
    rn1 = _feature$get['-1'],
    r1 = _feature$get['1'],
    r0 = _feature$get['0'],
    info = _objectWithoutProperties(_feature$get, ["refbase", "all", "total", "ref", "-1", "1", "0"]);
  var loc = [name, start === end ? en(start) : "".concat(en(start), "..").concat(en(end))].filter(function (f) {
    return !!f;
  }).join(':');
  return React.createElement("div", {
    ref: reactRef
  }, React.createElement("table", null, React.createElement("caption", null, loc), React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Base"), React.createElement("th", null, "Count"), React.createElement("th", null, "% of Total"), React.createElement("th", null, "Strands"), React.createElement("th", null, "Source"))), React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, "Total"), React.createElement("td", null, all)), React.createElement("tr", null, React.createElement("td", null, "REF ", refbase ? "(".concat(refbase.toUpperCase(), ")") : ''), React.createElement("td", null, ref), React.createElement("td", null, pct(ref, all)), React.createElement("td", null, rn1 ? "".concat(rn1, "(-)") : '', r1 ? "".concat(r1, "(+)") : ''), React.createElement("td", null)), Object.entries(info).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      entry = _ref3[1];
    return Object.entries(entry).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        base = _ref5[0],
        score = _ref5[1];
      return React.createElement("tr", {
        key: base
      }, React.createElement("td", null, base.toUpperCase()), React.createElement("td", null, score.total), React.createElement("td", null, base === 'total' || base === 'skip' ? '---' : pct(score.total, all)), React.createElement("td", null, score['-1'] ? "".concat(score['-1'], "(-)") : '', score['1'] ? "".concat(score['1'], "(+)") : ''), React.createElement("td", null, key));
    });
  }))));
});
var SNPCoverageTooltip = observer(function (props) {
  var model = props.model;
  var feat = model.featureUnderMouse;
  return feat && feat.get('type') === 'skip' ? null : React.createElement(Tooltip, _objectSpread({
    TooltipContents: TooltipContents
  }, props));
});
export default SNPCoverageTooltip;